import IncomeManager from '../features/accounting/IncomeManager';

export default function IncomePage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Gelirler</h1>
          <p>Günlük gelirleri platform ve ödeme yöntemine göre kaydedin.</p>
        </div>
      </header>
      <section className="page-section">
        <IncomeManager />
      </section>
    </div>
  );
}
